export class Address {
  street = ""
  city = ""
  zipCode = ""
  additional = ""
}
